<template>
  <div>
    <img src="../../assets/hscs/入库剪影/入库剪影.jpg" style="width:100vw;min-height:100vh" alt />
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  width: 100vw;
  height:1600px;
  font-size: 14px;
  background-image: url("../../assets/hscs/入库剪影/入库剪影.jpg");
  background-size: cover;

  .title {
    margin-top: 120px;
    font-size: 30px;
    font-weight: bold;
  }

  .content {
    margin-top: 16px;
    padding: 25px;
    height: 700px;
    background-color: #fef2f4;
    border-radius: 10px;
  }
}
</style>